import { create } from 'zustand';
import produce from 'immer';
import { notEquals } from '@higo/common/lib/utils';

const toValidId = (v: unknown): number | null => {
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : null;
};

export interface VisitsState {
  newVisits: number[];
  takenVisits: number[];

  actions: {
    addNewVisit: (visitId: number | string) => void;
    removeNewVisit: (visitId: number | string) => void;
    clearNewVisits: () => void;

    addTakenVisit: (visitId: number | string) => void;
    clearTakenVisits: () => void;
  };
}

const visitsStore = create<VisitsState>((set) => ({
  newVisits: [],
  takenVisits: [],

  actions: {
    addNewVisit: (visitId) =>
      set(
        produce((state: VisitsState) => {
          const id = toValidId(visitId);
          if (id === null) return;
          if (!state.newVisits.includes(id)) {
            state.newVisits.unshift(id);
          }
        }),
      ),

    removeNewVisit: (visitId) =>
      set(
        produce((state: VisitsState) => {
          const id = toValidId(visitId);
          if (id === null) return;
          state.newVisits = state.newVisits.filter(notEquals(id));
        }),
      ),

    clearNewVisits: () =>
      set(
        produce((state: VisitsState) => {
          state.newVisits = [];
        }),
      ),

    addTakenVisit: (visitId) =>
      set(
        produce((state: VisitsState) => {
          const id = toValidId(visitId);
          if (id === null) return;
          if (!state.takenVisits.includes(id)) {
            state.takenVisits.unshift(id);
          }
        }),
      ),

    clearTakenVisits: () =>
      set(
        produce((state: VisitsState) => {
          state.takenVisits = [];
        }),
      ),
  },
}));

export const useNewVisits = () =>
  visitsStore((state) => state.newVisits);

export const useVisitsStoreActions = () =>
  visitsStore((state) => state.actions);

export const useTakenVisits = () =>
  visitsStore((state) => state.takenVisits);
